import {cva} from 'platform/shared';
import {match} from 'ts-pattern';

import {ReactNode} from 'react';

import {cn} from '../../utils/cn';

export type AlignProps = {
  children: ReactNode;
  left?: boolean;
  right?: boolean;
  center?: boolean;
};

const alignVariants = cva('', {
  variants: {
    alignment: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
  },
  defaultVariants: {
    alignment: 'left',
  },
});

export function Align(props: AlignProps) {
  const alignment = match([Boolean(props.right), Boolean(props.center)])
    .with([true, false], [true, true], () => 'right' as const)
    .with([false, true], () => 'center' as const)
    .otherwise(() => 'left' as const);

  return <div className={cn(alignVariants({alignment}))}>{props.children}</div>;
}
